<template>
  <div id="export">
    <main-layout>
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab :key="'chat-log'" ripple :href="'#chat-log'">{{ $t('chat_log') }}</v-tab>
      </v-tabs>
      <template v-if="currentView == 'chat-log'">
        <v-container>
          <v-layout wrap>
            <v-flex xs6 px-2 class="form-control" :class="{ 'has-error': errors.has('formDate') }">
              <span>{{ $t('from') }}:</span>
              <v-menu
                ref="showFromDate"
                v-model="showFromDate"
                :close-on-content-click="false"
                full-width
                max-width="290px"
                color="primary"
              >
                <template #activator="{ on }">
                  <input
                    v-model="fromDate"
                    type="text"
                    class="form-control browser-default"
                    :placeholder="$t('Date')"
                    readonly
                    clearable
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="fromDate"
                  color="primary"
                  :max="maxDate"
                  @input="showFromDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6 px-2 class="form-control" :class="{ 'has-error': errors.has('toDate') }">
              <span>{{ $t('to') }}:</span>
              <v-menu
                ref="showToDate"
                v-model="showToDate"
                :close-on-content-click="false"
                full-width
                max-width="290px"
                color="primary"
              >
                <template #activator="{ on }">
                  <input
                    v-model="toDate"
                    type="text"
                    class="form-control browser-default"
                    :placeholder="$t('Date')"
                    readonly
                    clearable
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="toDate"
                  color="primary"
                  :max="maxDate"
                  @input="showToDate = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex>
              <v-btn color="primary" @click="handleDownloadChatLog">{{ $t('export') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </main-layout>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  data: function () {
    return {
      currentView: 'chat-log',
      maxDate: moment().format('YYYY-MM-DD'),
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      showFromDate: false,
      showToDate: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    async handleDownloadChatLog() {
      const vm = this
      vm.$store.dispatch('loading')
      try {
        const response = await api.exportChatLog({
          startDate: vm.fromDate,
          endDate: vm.toDate,
          pageId: vm.selectedBot.pageid
        })

        if (response.data) {
          const fileName = `CHATLOG_REPORT_${vm.fromDate}_${vm.toDate}.csv`
          const temp = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = temp
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
        }

        vm.$store.dispatch('loading')
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Export/Export.vue